import type { AxiosResponse } from 'axios';

import type { UseMutateAsyncFunction } from 'react-query';

import { createLocale } from 'locales';

import { useApiOrganisationPeriodJobsConfirmCreate } from 'state/__generated__/tadaahAPI';

import type { ErrorType } from 'state/custom-instance';

import { showErrorToast, showSuccessToast } from 'components/toast/toast';

import client from '../client';

const globalLocalize = createLocale('global');

interface useClosePeriodJobType {
  error: Error | null;
  isLoading: boolean;
  isSuccess: boolean;
  confirmPeriodJob: UseMutateAsyncFunction<
    AxiosResponse<void, unknown>,
    ErrorType<unknown>,
    {
      jobId: string;
      freelancerId: string;
    },
    unknown
  >;
}

const useConfirmPeriodJob = (callback?: () => void): useClosePeriodJobType => {
  const { isLoading, error, isSuccess, mutateAsync } =
    useApiOrganisationPeriodJobsConfirmCreate({
      mutation: {
        mutationKey: 'confirm-period-job',
        onError: (er) => {
          showErrorToast({
            description: er.message,
            title: globalLocalize('error'),
          });
          callback?.();
        },
        onSuccess: () => {
          showSuccessToast({
            description: globalLocalize('done'),
            title: globalLocalize('done'),
          });
          const queriesToInvalidate = ['organisation-period-jobs'];
          queriesToInvalidate.forEach((query) => {
            client.invalidateQueries(query);
          });
          callback?.();
        },
      },
    });

  return {
    confirmPeriodJob: mutateAsync,
    error,
    isLoading,
    isSuccess,
  };
};

export default useConfirmPeriodJob;
